export default __webpack_public_path__ + "static/media/7.88ab77f2.jpg";